import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { getAttributeValue } from 'domutils';
import { extractCssFromStyle } from '@slate-serializers/dom';
import { Types } from '../utils/contants.js';

var addAttributes = function addAttributes(tag, el) {
  return _objectSpread2({
    type: tag
  }, el !== null && el !== void 0 && el.attribs && Object.keys(el === null || el === void 0 ? void 0 : el.attribs).length > 0 ? el === null || el === void 0 ? void 0 : el.attribs : {});
};

var tagAttributes = function tagAttributes(el, type) {
  return _objectSpread2(_defineProperty({}, type, true), el !== null && el !== void 0 && el.attribs && Object.keys(el === null || el === void 0 ? void 0 : el.attribs).length > 0 ? el === null || el === void 0 ? void 0 : el.attribs : {});
};

var htmlToSlateConfig = {
  elementAttributeTransform: function elementAttributeTransform(_ref) {
    var el = _ref.el;
    var attrs = {};
    var elementStyleMap = {
      align: 'textAlign'
    };
    Object.keys(elementStyleMap).forEach(function (slateKey) {
      var cssProperty = elementStyleMap[slateKey];
      var cssValue = extractCssFromStyle(el, cssProperty);

      if (cssValue) {
        attrs[slateKey] = cssValue;
      }
    });
    return attrs;
  },
  elementTags: {
    img: function img(el) {
      return addAttributes('image', el);
    },
    a: function a(el) {
      return _objectSpread2(_objectSpread2({
        type: Types.link,
        newTab: true
      }, el !== null && el !== void 0 && el.attribs && Object.keys(el === null || el === void 0 ? void 0 : el.attribs).length > 0 ? el === null || el === void 0 ? void 0 : el.attribs : {}), {}, {
        url: el && getAttributeValue(el, 'href')
      });
    },
    blockquote: function blockquote() {
      return {
        type: 'blockquote'
      };
    },
    h1: function h1(el) {
      return addAttributes('heading-one', el);
    },
    h2: function h2(el) {
      return addAttributes('heading-two', el);
    },
    li: function li() {
      return {
        type: 'bulleted-list'
      };
    },
    ol: function ol() {
      return {
        type: 'numbered-list'
      };
    },
    ul: function ul() {
      return {
        type: 'ul'
      };
    },
    p: function p(el) {
      return addAttributes('p', el);
    },
    div: function div(el) {
      return addAttributes('div', el);
    },
    span: function span(el) {
      return addAttributes('span', el);
    },
    iframe: function iframe(el) {
      return addAttributes('iframe', el);
    }
  },
  textTags: {
    code: function code() {
      return {
        code: true
      };
    },
    pre: function pre() {
      return {
        code: true
      };
    },
    del: function del() {
      return {
        strikethrough: true
      };
    },
    em: function em(el) {
      return tagAttributes(el, 'italic');
    },
    i: function i(el) {
      return tagAttributes(el, 'italic');
    },
    s: function s() {
      return {
        strikethrough: true
      };
    },
    strong: function strong(el) {
      return tagAttributes(el, 'bold');
    },
    b: function b(el) {
      return tagAttributes(el, 'bold');
    },
    u: function u() {
      return {
        underline: true
      };
    }
  },
  htmlPreProcessString: function htmlPreProcessString(html) {
    return html === null || html === void 0 ? void 0 : html.replace(/<pre[^>]*>/g, '<code>').replace(/<\/pre>/g, '</code>');
  },
  filterWhitespaceNodes: true,
  convertBrToLineBreak: true,
  trimWhiteSpace: true
};
export { htmlToSlateConfig };